import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { isChrome } from "react-device-detect";
import { RadioGroup, FormControlLabel, Radio, TextField } from "@mui/material";
import {
  useLogin,
  useResetPasswordAfterLogin,
} from "../../api/authenticationApi";
import { Role } from "../../types/user";
import { resetTokens, setTokens } from "../../utils/tokenUtils";
import Dialog from "../../components/Dialog";
import "./login.scss";
import { LostPasswordDialog } from "./LoginDialog";

const Login = () => {
  const [role, setRole] = useState<Role>("student");
  const [id, setId] = useState("");
  const [password, setPassword] = useState("");
  const { mutateAsync: login } = useLogin();
  const { mutateAsync: resetPassword } = useResetPasswordAfterLogin({ role });

  const [openNewPasswordDialog, setOpenNewPasswordDialog] = useState(false);
  const [openLostPasswordDialog, setOpenLostPasswordDialog] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const navigate = useNavigate();

  const handleRoleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRole((event.target as HTMLInputElement).value as Role);
    setId("");
    setPassword("");
  };

  const handleSubmit = async () => {
    try {
      const result = await login({ role, id, password });
      const { access_token, refresh_token, name, change_password } = result;
      setTokens({ access_token, refresh_token });
      sessionStorage.setItem("name", name);

      if (!change_password) {
        setOpenNewPasswordDialog(true);
        return;
      }

      navigate(`/${role}`, { replace: true });
    } catch (error) {
      alert("로그인에 실패했습니다.");
    }
  };

  useEffect(() => {
    resetTokens();
  }, []);

  return (
    <div className="vertical center gap-normal">
      <h1>한양대 스포츠지도사</h1>
      <h1>로그인</h1>
      <TextField
        label="아이디"
        variant="standard"
        value={id}
        onChange={(e) => setId(e.target.value)}
      />
      <TextField
        label="비밀번호"
        variant="standard"
        value={password}
        type="password"
        onChange={(e) => setPassword(e.target.value)}
      />

      <RadioGroup row value={role} onChange={handleRoleChange}>
        <FormControlLabel value="student" control={<Radio />} label="학생" />
        <FormControlLabel value="staff" control={<Radio />} label="사무국" />
        <FormControlLabel
          value="instructor"
          control={<Radio />}
          label="지도자"
        />
      </RadioGroup>

      <button onClick={handleSubmit}>로그인</button>

      <div className="horizontal center">
        {/* <button>{role === "student" ? "연수 번호" : "아이디"} 찾기</button> */}
        <button onClick={() => setOpenLostPasswordDialog(true)}>
          비밀번호 분실
        </button>
      </div>
      {openLostPasswordDialog && (
        <LostPasswordDialog
          role={role}
          close={() => setOpenLostPasswordDialog(false)}
        />
      )}
      {openNewPasswordDialog && (
        <Dialog
          title="임시 비밀번호 변경"
          buttons={["ok"]}
          ok={async () => {
            if (newPassword !== confirmPassword) {
              alert("비밀번호가 일치하지 않습니다.");
              return;
            }
            await resetPassword({ password: newPassword });
            alert("성공적으로 변경되었습니다. 다시 로그인해주세요.");
            setPassword("");
            setOpenNewPasswordDialog(false);
          }}
          close={() => setOpenNewPasswordDialog(false)}
        >
          <div className="vertical center gap-normal" style={{ width: "100%" }}>
            <TextField
              label="새 비밀번호"
              type="password"
              variant="standard"
              value={newPassword}
              fullWidth
              onChange={(e) => setNewPassword(e.target.value)}
            />
            <TextField
              label="새 비밀번호 확인"
              type="password"
              variant="standard"
              value={confirmPassword}
              fullWidth
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </div>
        </Dialog>
      )}
    </div>
  );
};

export default Login;
